import { render } from "./DeviceList.vue?vue&type=template&id=2f970550&scoped=true"
import script from "./DeviceList.vue?vue&type=script&lang=js"
export * from "./DeviceList.vue?vue&type=script&lang=js"

import "./DeviceList.vue?vue&type=style&index=0&id=2f970550&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f970550"]])

export default __exports__